import {
  FeatureName,
  useAssetListFilter,
  useCurrentWorkspace,
  useIsFeatureEnabled,
  useSetAssetListFilter,
  WorkspaceType,
} from '@gripp/shared-logic';
import {
  AssetSearchInput,
  countFilters,
  FilterHeaders,
} from '@gripp/shared-ui';
import { Pressable, StyleSheet, View } from 'react-native';
import { useLocation, useNavigate, useParams } from 'react-router';
import { AddButton } from '../../shared/components/addButton/addButton';
import { AssetsFiltersOld } from './assetsFilters-old';

export const AssetsFilters = () => {
  const isCropCircleEnabled = useIsFeatureEnabled(
    FeatureName.CropCircleRedesign
  );
  if (!isCropCircleEnabled) {
    return <AssetsFiltersOld />;
  }
  return <AssetsFiltersBase />;
};

export const AssetsFiltersBase = () => {
  const navigate = useNavigate();
  const { assetId } = useParams();
  const location = useLocation();
  const workspace = useCurrentWorkspace();
  const isOEM = workspace?.type === WorkspaceType.Oem;

  const { data: assetFilter } = useAssetListFilter();
  const { mutateAsync: setAssetListFilter } = useSetAssetListFilter();
  const filterCount = countFilters(assetFilter);

  const onFilterNavigate = () => {
    if (location.pathname.includes(`/assets/${assetId}/detail`)) {
      navigate(`/assets/${assetId}/activity/filters`);
      return;
    }

    navigate(`/assets/filters`);
  };

  const onNewAssetNavigate = () => {
    navigate(`/assets/new`);
  };

  return (
    <View style={styles.filtersContainer}>
      <FilterHeaders
        currentSearchKeyword={assetFilter?.keyword}
        searchComponent={<AssetSearchInput />}
        onFilterPress={onFilterNavigate}
        onSearchClose={() =>
          setAssetListFilter({ ...assetFilter, keyword: '' })
        }
        filterCount={filterCount}
        Routes={{}}
      />

      {!isOEM && workspace && (
        <Pressable>
          <AddButton onPress={onNewAssetNavigate} />
        </Pressable>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  filtersContainer: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: 12,
  },
  searchButton: { padding: 8, borderRadius: 8 },
  filterButton: { padding: 8, borderRadius: 8 },
  filterButtonContent: { position: 'relative' },
  badgeContainer: { position: 'absolute', top: -6, right: -6 },
  modal: {
    alignSelf: 'center',
    backgroundColor: 'white',
    padding: 0,
    margin: 0,
    borderRadius: 10,
    width: 560,
    minHeight: 400,
  },
});
